import { render, staticRenderFns } from "./ChangeOwnerDialog.vue?vue&type=template&id=0e19ea2c&scoped=true&"
import script from "./ChangeOwnerDialog.vue?vue&type=script&lang=ts&"
export * from "./ChangeOwnerDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ChangeOwnerDialog.vue?vue&type=style&index=0&id=0e19ea2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e19ea2c",
  null
  
)

export default component.exports